export default __webpack_public_path__ + "static/SSSpyView_screenshot-2-2f1124b2c807d4b8cfbda3f935306f88.webp";